export default "__VITE_ASSET__DiAHStFB__"